import ProviderAPI from "../redux/ProviderAPI";

export const getZone = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/zone",
    data,
    token,
  });
  return result;
};

export const AddZone = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addzonename",
    data,
    token,
  });
  return result;
};

export const DeleteZone = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deletezonename",
    data,
    token,
  });
  return result;
};

export const getFloor = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/floor",
    data,
    token,
  });
  return result;
};

export const AddFloor = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addfloor",
    data,
    token,
  });
  return result;
};

export const DeleteFloor = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deletefloor",
    data,
    token,
  });
  return result;
};

export const AddAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addasset",
    data,
    token,
  });
  return result;
};

export const getAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getasset",
    data,
    token,
  });
  return result;
};

export const RoomAndProperty = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/roomandpropety",
    data,
    token,
  });
  return result;
};

export const AddRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addroom",
    data,
    token,
  });
  return result;
};

export const getFeeType = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/feetype",
    data,
    token,
  });
  return result;
};

export const AddRoomSize = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/roomsize",
    data,
    token,
  });
  return result;
};

export const getFacilities = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/facilities",
    data,
    token,
  });
  return result;
};

export const getUnit = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/unitsize",
    data,
    token,
  });
  return result;
};

export const getAssetType = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getassettype",
    data,
    token,
  });
  return result;
};

export const getRoomAndProperty = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getroomAndProperty",
    data,
    token,
  });
  return result;
};

// export const getRoomdetaillist = async (data, token) => {
//   const result = await ProviderAPI({
//     type: "GET",
//     url: "/assetprofile/getroomdetail",
//     data,
//     token,
//   });
//   return result;
// };

export const getAddFee = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getAddFee",
    data,
    token,
  });
  return result;
};

export const getNewAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getnewasset",
    data,
    token,
  });
  return result;
};

export const addFeeDtails = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addFeeDetails",
    data,
    token,
  });
  return result;
};

export const getFeeDtails = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/getFeeDetails",
    data,
    token,
  });
  return result;
};

export const getResultsAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/resultsAsset",
    data,
    token,
  });
  return result;
};

export const editAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/editAsset",
    data,
    token,
  });
  return result;
};

export const deleteRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deleteRoom",
    data,
    token,
  });
  return result;
};

export const editFeeDetails = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/editFeeDetails",
    data,
    token,
  });
  return result;
};

export const editRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/editRoom",
    data,
    token,
  });
  return result;
};

export const addMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addMapSetup",
    data,
    token,
  });
  return result;
};

export const getMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/resultsMap",
    data,
    token,
  });
  return result;
};

export const postImageMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/addImageMapSetup",
    data,
    token,
  });
  return result;
};

export const getImageMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/assetprofile/resultsImgMap",
    data,
    token,
  });
  return result;
};

export const deleteMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deleteMapSetup",
    data,
    token,
  });
  return result;
};

export const editMapSetup = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/editMapSetup",
    data,
    token,
  });
  return result;
};

export const deleteImgMap = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deleteImageMapSetup",
    data,
    token,
  });
  return result;
};

export const deleteAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deleteAsset",
    data,
    token,
  });
  return result;
};

export const editContractExpired = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/assetprofile/editContractExpired",
    data,
    token,
  });
  return result;
};

export const deleteFeeDetails = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/assetprofile/deleteFeeDetails",
    data,
    token,
  });
  return result;
};
